import { render, staticRenderFns } from "./ChatRooms.vue?vue&type=template&id=50161860&scoped=true"
import script from "./ChatRooms.vue?vue&type=script&lang=js"
export * from "./ChatRooms.vue?vue&type=script&lang=js"
import style0 from "./ChatRooms.vue?vue&type=style&index=0&id=50161860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50161860",
  null
  
)

export default component.exports